import { IconListTree } from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import { SearchResult } from '~/portal/types/search'

interface ChannelSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const ChannelSearchResultTile = ({ result, onClose, tileKey }: ChannelSearchResultTileProps) => {
  const url = `/${result.product.slug}/${result.href}`

  const icon = (
    <span className="mt-px">
      <IconListTree />
    </span>
  )

  const titleContent = (
    <div>
      Channels
      {' / '}
      <HighlightedTitle titleSnippet={result.titleSnippet} removeLeadingSlash={!result.summary} />
    </div>
  )

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={icon}
      url={url}
      titleContent={titleContent}
    />
  )
}